import { useContext } from 'react';
import VestingContext from '../contexts/VestingContext';

const useVestingContext = () => useContext(VestingContext);

export default useVestingContext;
